import "./RedirectButton.css"

const RedirectButton = ({ reDirect }) => {

    return (
      <button className='redirect btn rounded-pill' onClick={reDirect}>Redirect</button>
    )
};

export default RedirectButton;